import { render, staticRenderFns } from "./FloppyDisk.vue?vue&type=template&id=288ac90e&scoped=true"
import script from "./FloppyDisk.vue?vue&type=script&lang=js"
export * from "./FloppyDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ac90e",
  null
  
)

export default component.exports